<template>
  <div class="text-left">
    <h5 class="text-center">
      <strong>{{ $t("name") }}:</strong> {{ title }}
      <span class="ml-5" v-if="supervisor"
        ><strong> Supervisor:</strong> {{ supervisor.username }}</span
      >
    </h5>
    <v-divider />
    <v-card>
      <form class="pa-6">
            <h5>
              {{ $t("form.givenAndFamilyName") }}
            </h5>
            <v-row>
              <v-col cols="12" md="6" class="pb-0">
                <v-text-field
                  v-model="investigator.person.preferred_name.given_name"
                  @blur="normalizePersonNameField(investigator.person.preferred_name, 'given_name')"
                  :label="$t('form.name')"
                  outlined
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pb-0">
                <v-text-field
                  v-model="investigator.person.preferred_name.family_name"
                  @blur="normalizePersonNameField(investigator.person.preferred_name, 'family_name')"
                  :label="$t('form.familyName')"
                  outlined
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
            <h5>{{ $t("form.email") }}</h5>
            <ArrayFieldForm
              :read-only="true"
              v-model="investigator.person.email"
              name-field="email"
            />
            <h5>{{ $t("form.incharge") }}</h5>
            <SelectPeopleList
              :disabled-form="true"
              :items-selected="investigator.person.incharge"
            />

            <v-row>
              <v-col cols="12" md="6" class="pb-0">
                <h5>
                  {{ $t("form.dni") }}
                </h5>
                <v-row>
                  <v-col cols="4" class="pb-0">
                    <v-select
                      v-model="investigator.person.id_number.type"
                      :label="$t('type')"
                      outlined
                      :items="identificationOptions"
                      item-text="text"
                      item-value="value"
                      readonly
                    ></v-select
                  ></v-col>
                  <v-col cols="8" class="pb-0">
                    <v-text-field
                      v-model="investigator.person.id_number.value"
                      :label="$t('label.value')"
                      required
                      outlined
                      readonly
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="3" class="pb-0">
                <h5>
                  {{ $t("form.mobile") }}
                </h5>
                <v-row>
                  <v-col class="pb-0">
                    <v-text-field
                      v-model="investigator.person.number"
                      outlined
                      :label="$t('form.mobile')"
                      readonly
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="3" class="pb-0">
                <h5>{{ $t("form.gender") }}</h5>
                <v-row>
                  <v-col class="pb-0 mt-1">
                    <v-btn-toggle
                      v-model="investigator.person.gender"
                      mandatory
                      disabled=""
                    >
                      <v-btn value="male" class="disable-events">
                        {{ $t("form.male") }}
                      </v-btn>
                      <v-btn value="female" class="disable-events">
                        {{ $t("form.female") }}
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <h5>
              {{ $t("form.motivationAccount") }}
            </h5>
            <v-text-field
              v-model="investigator.motivation"
              outlined
              :label="$t('form.motivationAccount')"
              readonly
            ></v-text-field>

            <h5 class="bold text-left mb-5">
              {{ $t("form.list.additional.services") }}
            </h5>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
                lg="3"
                v-for="(service, index) in sortedServices"
                :key="index"
                class="py-0"
              >
                <v-checkbox
                  v-model="investigator.account.services"
                  :label="service.name"
                  :value="service.id"
                  readonly
                  off-icon="mdi-close"
                  on-icon="mdi-check-circle"
                  class="py-0 my-0"
                  dense
                />
              </v-col>
            </v-row>

      <v-divider />
      <DirectorActions v-if="isAuthorize" :object_type="object_type" />
      <SupervisorActions
        v-else
        :item="investigator"
        :object_type="object_type"
        :form_name="form_name"
        :state="state"
        :supervisor="supervisor !== null ? supervisor.username : ''"
        @change-state-supervisor="onStateSupervisorChange"
      />
    </form>
  </v-card>
  </div>
</template>

<script>
import axios from "axios";
import DirectorActions from "../../action_buttons/DirectorActions";
import SupervisorActions from "../../action_buttons/SupervisorActions";
import ArrayFieldForm from "../../reusables/ArrayFieldForm";
import SelectPeopleList from "../../reusables/SelectPeopleList";
import investigatorData from "../../../mixins/investigator_data";
import investigator_model from "../../../mixins/model_utils/investigator_model";

export default {
  mixins: [investigatorData, investigator_model],
  components: {
    SelectPeopleList,
    DirectorActions,
    SupervisorActions,
    ArrayFieldForm
  },
  data: () => ({
    step: 1,
    tab: null,
    menu: false,
    state: "",
    form_name: "",
    title: "",
    reject_comment: "",
    object_type: "",
    supervisor: ""
  }),

  computed: {
    isAuthorize() {
      return this.$route.meta.authorize !== undefined;
    }
  },

  created() {
    this.getServices();
    this.getResearchAreas();
    this.getData();
  },

  methods: {
    getData() {
      let path;
      if (this.isAuthorize) {
        path =
          this.$store.state.endpoint +
          "/direction/moderatedOperations/authorize/investigator/" +
          this.$route.params.id;
      } else {
        path =
          this.$store.state.endpoint +
          "/moderatedOperations/review/investigator/" +
          this.$route.params.id;
      }
      axios
        .get(path)
        .then(response => {
          this.investigator = response.data.data.user;
          this.state = response.data.state;
          this.title = response.data.title;
          this.form_name = response.data.form_name;
          this.reject_comment = response.data.reject_comment;
          this.object_type = response.data.object_type;
          this.investigator.id = response.data.object_id;
          this.supervisor = response.data.supervisor;
          this.motivation = response.data.motivation;
        })
        .catch(error => {
          console.log(error);
        });
    },

    onStateSupervisorChange(state, supervisor) {
      this.state = state;
      this.supervisor = supervisor;
    }
  }
};
</script>
